import axiosSetting from '@/common/axiosSetting'
const state = {
	pactNum : 0
};
const mutations = {
	increment (state,n) {
		state.pactNum = n;
	}
};
const actions = {
	incrementAsync ({ commit }) {
		let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
		if(userInfo.id && userInfo.wap_role !== 'shoper' && userInfo.wap_role !== 'admin'){
			axiosSetting.AxiosIns({
				url : 'contract/sign_count.json'
			}).then((res)=>{
				commit('increment',res.wait)
			});
		}
	}
};
export default {
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/pactTotal.js